import React from "react";

const SegmentedControl = ({
  value,
  onChange,
  options = [],
  className = "",
}) => {
  return (
    <div className={["flex items-center border border-border rounded-lg overflow-hidden bg-white", className].join(" ")}>
      {options.map((opt, i) => {
        const isActive = opt.value === value;
        const isLast = i === options.length - 1;
        return (
          <button
            key={opt.value}
            onClick={() => onChange(opt.value)}
            style={{
              backgroundColor: isActive ? "#004BB5" : "#ffffff",
              color: isActive ? "#ffffff" : "var(--ink-700)",
            }}
            className={[
              "px-3 py-1.5 text-xs font-semibold cursor-pointer transition-colors duration-150 flex items-center gap-1",
              !isLast ? "border-r border-border" : "",
              !isActive ? "hover:bg-canvas" : ""
            ].join(" ")}
          >
            {opt.icon && opt.icon}
            <span>{opt.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default SegmentedControl;
